/**
 * Like generateQueryUrl, but for fields whose backend column may be numeric
 * (e.g. zip code, phone), where Django's `__iexact`/`__icontains` lookups
 * aren't valid on non-char fields. Falls back to case-sensitive `contains`/`=`
 * when the token value looks like a number.
 */
export const generateNumericAwareQueryUrl = (url, tokens = []) => {
  if (!tokens.length) return url;

  let queryUrl = `${url}?`;
  tokens.forEach((token, index) => {
    const lastElement = index === tokens.length - 1;
    const category = token.category.value;
    const operator = token.operator;
    const value = token.value.value;

    if (typeof value === "string") {
      const isNumeric = !isNaN(Number(value));
      queryUrl = `${queryUrl}${category}${
        operator === "contains"
          ? `__${isNumeric ? "contains" : "icontains"}=`
          : `${isNumeric ? "" : "__iexact"}${operator}`
      }${value}${!lastElement ? "&" : ""}`;
    } else {
      // boolean value
      queryUrl = `${queryUrl}${category}${operator}${value}${!lastElement ? "&" : ""}`;
    }
  });

  return queryUrl;
};
